import React from 'react';
import { Snowflake, Plus } from 'lucide-react';
import { FaUserLock } from 'react-icons/fa';
import { FaUsers } from 'react-icons/fa6';

function SnowflakePlusIcon({ size = 12, className = '', plusBgClass = 'bg-white' }) {
  return (
    <div
      className={`relative inline-block shrink-0 ${className}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <Snowflake size={size} />
      <div
        className={`absolute rounded-full flex items-center justify-center ${plusBgClass}`}
        style={{
          width: size * 0.5,
          height: size * 0.5,
          bottom: -size * 0.08,
          right: -size * 0.08,
          border: '1.5px solid currentColor',
        }}
      >
        <Plus size={size * 0.35} strokeWidth={3} />
      </div>
    </div>
  );
}

const badgeBase =
  'inline-flex items-center justify-center shrink-0 rounded border p-0.5 shadow-sm';

/**
 * Icon-only freeze badges for driver headers (Trips / Buckets / Maps).
 * Freeze = solid teal (locked). Freeze Pre-Assign = solid blue (locked + can grow).
 */
export function DriverFreezeTypeBadge({ freezeType }) {
  if (freezeType === 'freeze') {
    return (
      <span
        title="Freeze"
        aria-label="Freeze"
        className={`${badgeBase} border-teal-700 bg-teal-500 text-white`}
      >
        <Snowflake className="w-3 h-3 shrink-0" aria-hidden />
      </span>
    );
  }

  if (freezeType === 'freeze_pre_assign') {
    return (
      <span
        title="Freeze Pre assign"
        aria-label="Freeze Pre assign"
        className={`${badgeBase} border-blue-700 bg-blue-600 text-white`}
      >
        <SnowflakePlusIcon size={12} plusBgClass="bg-blue-500" />
      </span>
    );
  }

  if (freezeType === 'preserved') {
    return (
      <span
        title="Preserved"
        aria-label="Preserved"
        className={`${badgeBase} border-fuchsia-700 bg-fuchsia-600 text-white`}
      >
        <FaUserLock className="w-3 h-3 shrink-0" aria-hidden />
      </span>
    );
  }

  return null;
}

export function driverHasMultiload(driver) {
  if (driver?.has_multiload === true) return true;
  return (driver?.trips || []).some(
    (t) => t?.is_multiload === true && t?.multiload_group_id != null && String(t.multiload_group_id).trim() !== ''
  );
}

/**
 * Icon-only multiload badge for driver headers (Trips / Buckets / Maps).
 * Shown when the driver's current bucket has at least one multiload trip.
 */
export function DriverMultiloadBadge({ driver }) {
  if (!driverHasMultiload(driver)) return null;
  return (
    <span
      title="Multiload"
      aria-label="Multiload"
      className={`${badgeBase} border-orange-700 bg-orange-500 text-white`}
    >
      <FaUsers className="w-3 h-3 shrink-0" aria-hidden />
    </span>
  );
}

export default DriverFreezeTypeBadge;
